import React, { useState, useEffect, useMemo } from 'react';
import IconItem from 'components/common/icon/IconItem';
import IconButton from 'components/common/IconButton';
import axios from 'helpers/api';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import { Badge, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';

const DrugListTable = (props) => {
    const [druglist, setDrugList] = useState([]);
    const [statusFilter, setStatusFilter] = useState('active');

    function handleEditInput(editValue) {
        props.onCallEditParent(editValue);
    }

    const columns = useMemo(() => [
        {
            accessorKey: 'drug',
            header: 'Drug',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'strength',
            header: 'Strength',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'strengthValue',
            header: 'Strength Value',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'ndc',
            header: 'NDC',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'brand_drug',
            header: 'Brand',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'generic',
            header: 'Generic',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'drug_form',
            header: 'Drug Form',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'caution1',
            header: 'Caution 1',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'caution2',
            header: 'Caution 2',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'caution3',
            header: 'Caution 3',
            meta: {
               headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        // {
        //     accessorKey: 'is_active',
        //     header: 'Status',
        //     meta: {
        //         headerProps: { className: 'text-900 text-center' },
        //         cellProps: { className: 'text-center' }
        //     },
        //     cell: ({ row: { original } }) => {
        //         const isActive = original.is_active == 1 || original.is_active === '1' || original.is_active === true;
        //         return (
        //             <Badge bg={isActive ? 'success' : 'secondary'}>
        //                 {isActive ? 'Active' : 'Inactive'}
        //             </Badge>
        //         );
        //     }
        // },
        {
            accessorKey: 'Action',
            header: 'Action',
            meta: {
                headerProps: { className: 'text-900 text-center', style: { width: '100px' } },
                cellProps: { className: 'text-center align-middle', style: { width: '100px' } }
            },
            enableSorting: false,
            cell: ({ row: { original } }) => {
                return (
                    <div className="d-flex justify-content-center align-items-center">
                        <IconItem
                            tag="button"
                            icon={['far', 'edit']}
                            size="sm"
                            onClick={() => handleEditInput(original)}
                            className="btn rounded-3 fs-11 align-items-center"
                        />
                    </div>
                );
            }
        }
    ], []);

    useEffect(() => {
        async function fetchDrugList() {
            let tokenStr = localStorage.getItem("accessToken");
            try {
                const drugData = await axios.get(`${process.env.REACT_APP_SERVER_URL}/drugs/list-group-drugs`, {
                    headers: { 'Authorization': `Bearer ${tokenStr}` }
                });

                let dataObj = drugData?.data?.drugs?.data || drugData?.data?.data;
                if (dataObj) {
                    const results = dataObj.map(value => ({
                        drug: value.drug,
                        strength: value.strength,
                        strengthValue: value.strength_value,
                        ndc: value.ndc,
                        generic: value.generic,
                        brand_drug: value.brand_drug,
                        caution1: value.caution1,
                        caution2: value.caution2,
                        caution3: value.caution3,
                        drug_form: value.drug_form,
                        drug_id: value.id,
                        // is_active: value.is_active !== undefined ? value.is_active : 1
                    }));
                    setDrugList(results);
                } else {
                    setDrugList([]);
                }
            } catch (err) {
                toast.info("No Drugs found in this list");
                setDrugList([]);
            }
        }

        fetchDrugList();
    }, [props.trigger]);

    // const filteredData = useMemo(() => {
    //     return druglist.filter(item => {
    //         const isActive = item.is_active == 1 || item.is_active === '1' || item.is_active === true;
    //         if (statusFilter === 'active') return isActive;
    //         if (statusFilter === 'inactive') return !isActive;
    //         return true;
    //     });
    // }, [druglist, statusFilter]);

    const table = useAdvanceTable({
        data: druglist,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    return (
        <div>
            <AdvanceTableProvider {...table}>
                <Row className="g-2 align-items-center mb-3">
                    <Col md={4}>
                        <AdvanceTableSearchBox placeholder="Search..." />
                    </Col>
                    {/* <Col md={4} className="d-flex align-items-center gap-2">
                        <Form.Label className="mb-0 text-nowrap fw-semi-bold fs-10">Filter:</Form.Label>
                        <Form.Select
                            size="sm"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            style={{ minWidth: '150px' }}
                        >
                            <option value="active">Active Drug</option>
                            <option value="inactive">Inactive Drug</option>
                            <option value="all">All Drug</option>
                        </Form.Select>
                    </Col> */}
                    <Col md={4} className="ms-auto d-flex justify-content-end">
                        <IconButton
                            variant="primary"
                            size="sm"
                            icon="plus"
                            transform="shrink-3 down-2"
                            onClick={props.onOpenAddModal}
                        >
                            Add Drug
                        </IconButton>
                    </Col>
                </Row>
                {druglist.length > 0 ? (
                    <AdvanceTable
                        headerClassName="bg-200 text-nowrap align-middle text-center"
                        rowClassName="text-nowrap align-middle"
                        tableProps={{
                            size: 'lg',
                            striped: true,
                            className: 'fs-10 mb-0'
                        }}
                    />
                ) : (
                    <div className="d-flex justify-content-center align-items-center text-center py-4">
                        <p className="text-danger fw-bold mb-0">There is no data available in the table</p>
                    </div>
                )}
                <div className="mt-3">
                    <AdvanceTableFooter
                        rowInfo
                        navButtons
                        rowsPerPageSelection
                    />
                </div>
            </AdvanceTableProvider>
        </div>
    );
};

export default DrugListTable;



